export default __webpack_public_path__ + "static/media/broker.cc7f47ca.svg";